import { Route } from '@angular/router';
import { AdminDashboardComponent } from '../components/admin-dashboard/admin-dashboard.component';
import { DbcOrdersComponent } from '../components/dbc-orders/dbc-orders.component';
import { OrganizationsComponent } from '../components/organizations/organizations.component';
import { UsersComponent } from '../components/users/users.component';
import { DeletionOperationsComponent } from '../components/deletion-operations/deletion-operations.component';

/**
 * Admin panel child routing configuration.
 * These are the routes that load INSIDE the AdminpanelComponent <router-outlet>.
 */
export const ADMIN_ROUTES: Route[] = [
  {
    path: '',
    component: AdminDashboardComponent,
    data: { page: 'admin-dashboard', breadcrumb: 'Dashboard' }
  },
  {
    path: 'users',
    component: UsersComponent,
    data: { page: 'users', breadcrumb: 'Users' }
  },
  {
    path: 'organizations',
    component: OrganizationsComponent,
    data: { page: 'organizations', breadcrumb: 'Organizations' }
  },
  {
    path: 'deletion-operations',
    component: DeletionOperationsComponent,
    data: { page: 'deletion-operations', breadcrumb: 'Deletion Operations' }
  },
  {
    path: 'dbc-orders',
    component: DbcOrdersComponent,
    data: { page: 'dbc-orders', breadcrumb: 'DBC Orders' }
  }
];

/**
 * Get the child routes for menu generation
 * @returns Array of child routes that can be used for dynamic menu creation
 */
export function getAdminChildRoutes(): Route[] {
  // Since ADMIN_ROUTES is now just the list of children, return it directly
  return ADMIN_ROUTES;
}
